import React from 'react';

export interface TextProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'h1' | 'h2' | 'h3' | 'label' | 'pill' | 'body' | 'caption';
  align?: 'left' | 'center' | 'right';
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

/**
 * Web equivalent of `apps/WunderGuide/common/Text.tsx`. Variants mirror RN.
 * Sizes/weights live in common.css under .text-* classes.
 */
const Text: React.FC<TextProps> = ({
  children,
  variant = 'body',
  align = 'left',
  style,
  className = '',
  ...props
}) => {
  const variantClass = `text-${variant}`;
  const alignmentClass = `text-${align}`;
  const combined = `${variantClass} ${alignmentClass} ${className}`.trim();
  return (
    <div className={combined} style={style} {...props}>
      {children}
    </div>
  );
};

export default Text;
